import React, { createContext, useContext, useEffect, useState } from 'react';

export const THEMES = {
  v1: {
    label: 'Neon Midnight',
    icon: '💜',
    swatches: ['#07060e', '#ffeb3b', '#00eeff', '#ff44cc'],
  },
  v2: {
    label: 'Retro Marquee',
    icon: '🟠',
    swatches: ['#110800', '#f5a623', '#ff5500', '#ffcc00'],
  },
  v3: {
    label: 'Emerald Flash',
    icon: '💚',
    swatches: ['#040f06', '#39ff14', '#00ffcc', '#ff00aa'],
  },
};

export const ThemeContext = createContext({ theme: 'v1', setTheme: () => {} });

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(
    () => localStorage.getItem('cpp-theme') || 'v1'
  );

  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem('cpp-theme', theme);
  }, [theme]);

  // Apply initial theme before first render
  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
